
namespace GeniuzPOS.Supplier {

    @Serenity.Decorators.registerClass()
    export class CsSupplTypeGrid extends Serenity.EntityGrid<CsSupplTypeRow, any> {
        protected getColumnsKey() { return CsSupplTypeColumns.columnsKey; }
        protected getDialogType() { return CsSupplTypeDialog; }
        protected getIdProperty() { return CsSupplTypeRow.idProperty; }
        protected getInsertPermission() { return CsSupplTypeRow.insertPermission; }
        protected getLocalTextPrefix() { return CsSupplTypeRow.localTextPrefix; }
        protected getService() { return CsSupplTypeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}